// src/redux/company/companiesApi.js
import { endpoints } from "../apiEndpoints/apiEndpoints";
import apiService from "../services/apiCore";

// ✅ Add Company (FormData)
export const addCompanyAPI = async (formData) => {
  try {
    const response = await apiService.postFormData(endpoints.addCompany, formData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Update Company (FormData)
export const updateCompanyAPI = async ({ id, formData }) => {
  try {
    const response = await apiService.putFormData(`${endpoints.updateCompany}/${id}`, formData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Company List
export const getCompanyListAPI = async ({ page = 1, limit = 10, search = "", is_archived = '' } = {}) => {
  try {
    // include status in query params so backend can filter (default 'all')
    const params = { page, limit, search, is_archived };
    const response = await apiService.get(endpoints.getCompanyList, params);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Company Detail
export const getCompanyDetailAPI = async (id) => {
  try {
    const response = await apiService.get(`${endpoints.getCompanyDetail}/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Archive/Unarchive Company
export const archiveCompanyAPI = async (id, isArchive = true) => {
  try {
    const response = await apiService.put(`/company/archive/${id}`, { is_archive: isArchive });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Company Coaches
export const getCompanyCoachesAPI = async (
  companyId,
  { page = 1, limit = 10, search = "" } = {}
) => {
  try {
    const params = { page, limit, search };
    const endpoint = endpoints.getCompanyCoaches.replace(':id', companyId);
    const response = await apiService.get(endpoint, params);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Remove Company Coach
export const removeCompanyCoachAPI = async (coachId, companyId) => {
  try {
    const url = companyId
      ? `/company/coach/remove/${coachId}?company_id=${companyId}`
      : `/company/coach/remove/${coachId}`;
    const response = await apiService.delete(url);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Update Company HR
export const updateCompanyHRAPI = async (companyId, hrData) => {
  try {
    const response = await apiService.put(`/company/hr/${companyId}`, hrData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Company Stats (Employee & Batch Count)
export const getCompanyStatsAPI = async (companyId) => {
  try {
    const response = await apiService.get(`/company/${companyId}/stats`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Company Activity Logs
export const getCompanyActivityLogsAPI = async (companyId, { page = 1, limit = 10 } = {}) => {
  try {
    const params = { page, limit };
    const response = await apiService.get(`${endpoints.getCompanyActivityLogs}/${companyId}`, params);
    return response.data;
  } catch (error) {
    throw error;
  }
};